import { toast } from "sonner";

const Alert = {
  success: (description) => toast.success(description),
  error: (description) => toast.error(description),
};

export default Alert;
